import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selected_list_element = _resolveComponent("selected-list-element")!
  const _component_DndProvider = _resolveComponent("DndProvider")!

  return (_openBlock(), _createBlock(_component_DndProvider, {
    backend: _ctx.HTML5Backend,
    context: _ctx._WINDOW_
  }, {
    default: _withCtx(() => [
      _createVNode(_TransitionGroup, {
        name: "list",
        tag: "div"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputItems, (element) => {
            return (_openBlock(), _createBlock(_component_selected_list_element, {
              element: element,
              key: element.compound_id+'_g'+element.GroupId+'_'+element.compound_name,
              "input-index": element.Position,
              "parent-id": undefined,
              "parent-name": '',
              "parent-idx": element.compound_id+'_g'+element.GroupId+'_'+element.compound_name,
              "is-root": true,
              "allow-hover-action": _ctx.allowHoverAction,
              draggable: true,
              "grouping-mode": _ctx.groupingMode,
              onChangePosition: _ctx.moveStoreItem,
              onChangeSelection: _ctx.onModelUpdate,
              onAddToGroup: ($event: any) => (_ctx.onAddToGroup(element.compound_id)),
              onRemoveFromGroup: ($event: any) => (_ctx.onRemoveFromGroup(element.compound_id)),
              onTogglesChange: _ctx.onTogglesChange,
              onRangeChange: _ctx.onRangeChange,
              onUnGroupClick: _ctx.onUnGroupClick,
              onUnGroupSingleClick: _ctx.onUnGroupSingleClick,
              "scroll-viewport": _ctx.scrollViewport
            }, null, 8, ["element", "input-index", "parent-idx", "allow-hover-action", "grouping-mode", "onChangePosition", "onChangeSelection", "onAddToGroup", "onRemoveFromGroup", "onTogglesChange", "onRangeChange", "onUnGroupClick", "onUnGroupSingleClick", "scroll-viewport"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["backend", "context"]))
}